module.exports = __webpack_public_path__ + "media/images/sp/maedori_photowedding/plan_chapel-80c9772eeb024335d275c0dab077b047.webp";